export default __webpack_public_path__ + "static/media/icon_date_time.64d4e861.svg";